import React from 'react';
import moment from 'moment';
import { Trans } from 'react-i18next';

import { useGeolocationContext } from '../hooks/geolocationContext';

import { P3, P4 } from '../../../../Common/DesignSystem/Text';
import colours from '../../../../Common/DesignSystem/Colours';

export const DataUpdateInfo = () => {
	const { refreshTimeInSeconds, lastUpdated } = useGeolocationContext();

	return (
		<div className="data-update-info">
			<div className="blue-circle"></div>
			<div>
				<P3><Trans>Real Time Updates</Trans></P3>
				<P4 style={{ color: colours.primary.grey02 }}>
					<Trans>Update frequency: </Trans>
					{refreshTimeInSeconds}
					<Trans> seconds</Trans>
				</P4>
				<P4 style={{ color: colours.primary.grey02 }}>
					<Trans>Last Update: </Trans>
					{moment(lastUpdated).format('MMM D, YYYY h:mm')}
				</P4>
			</div>
		</div>
	)
};
